export default "__VITE_ASSET__Cft_uLsO__"